import React from 'react';
import { Search } from 'lucide-react';

const DiplomeSearch = ({ searchTerm, onSearchChange }) => {
    return (
        <div className="mb-6">
            <div className="relative max-w-md">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <Search className="h-5 w-5 text-gray-400" />
                </div>
                <input
                    type="text"
                    value={searchTerm}
                    onChange={onSearchChange}
                    placeholder="Rechercher un diplôme ou un établissement..."
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                />
            </div>
        </div>
    );
};

export default DiplomeSearch;
